export class AppModeService {
    public static get isDevelopmentMode() {
        return location.port === '4200';
    }
    public static get isStaging() {
        return location.href.includes('staging');
    }

}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/services/app.mode.service.ts